import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Body2, mergeClasses, Title2 } from '@fluentui/react-components';

import { useBannerContainerStyles } from './style';

export const Banner = ({ i18n }) => {
  const classes = useBannerContainerStyles();

  return (
    <div className={mergeClasses(
      'ads-studio-top-banner-container',
      classes.bannerContainer
    )}
    >
      <div>
        <Title2 className={mergeClasses('display-templates-banner-title', classes.heading)} block>
          {i18n.getString(_TL_('Display templates'))}
        </Title2>
        <Body2 className="display-templates-banner-description">
          {i18n.getString(_TL_('Create visually appealing templates for your Display ads to save time during campaign creation.'))}
        </Body2>
      </div>
    </div>
  );
};

Banner.propTypes = {
  i18n: PropTypes.shape({ getString: func }).isRequired,
};

